var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "./BaseModel";
import { forEach, filter, map, reduce, find } from 'lodash';
import GroupModel from "@/models/GroupModel";
var BundleModel = /** @class */ (function (_super) {
    __extends(BundleModel, _super);
    function BundleModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = data.bundle_id || hydrated.id;
        _this.groups = null;
        if (data.groups) {
            _this.groups = map(hydrated.groups, function (group) {
                return new GroupModel(group);
            });
        }
        _this.meal = hydrated.meal;
        // TODO improve model hydration, should not be checking for api sent property
        _this.discount = hydrated.discount || hydrated.default_discount;
        _this.items = hydrated.items;
        forEach(_this.items, function (item) {
            item.inBundle = true;
        });
        _this.__mc = 'BundleModel';
        return _this;
    }
    BundleModel.prototype.getBundleTotal = function () {
        var total = 0;
        var bundleItems = this.items;
        forEach(bundleItems, function (item) {
            total += item.getItemTotal();
        });
        return total;
    };
    BundleModel.prototype.getBundleBasePrice = function (optionExceptions) {
        var total = 0;
        var items = this.items;
        total = reduce(items, function (accumulator, item) {
            var itemExceptions = find(optionExceptions, function (exception) {
                if (exception) {
                    var exceptionItemId = exception.parentId;
                    return exceptionItemId === item.id;
                }
                return false;
            });
            return accumulator += item.getBasePrice(itemExceptions);
        }, 0);
        return total;
    };
    BundleModel.prototype.setItems = function (items) {
        this.items = items;
    };
    BundleModel.prototype.extractLineItemsFromGroups = function () {
        var _this = this;
        var groups = this.groups;
        this.items = [];
        forEach(groups, function (group) {
            var _a;
            var items = group.items;
            (_a = _this.items).push.apply(_a, items);
        });
    };
    BundleModel.prototype.hydrate = function (data) {
        var bundle = {};
        bundle = data;
        return bundle;
    };
    BundleModel.prototype.hydrateFromStore = function (data) {
        var bundle = {};
        bundle = data;
        return bundle;
    };
    BundleModel.prototype.exportModel = function (locationBase) {
        var _this = this;
        var exportedGroups = this.groups.map(function (group) {
            var itemsInGroup = filter(_this.items, function (item) {
                return item.parentGroupId === group.id;
            });
            return group.exportedModel(itemsInGroup, locationBase);
        });
        return {
            groups: exportedGroups,
        };
    };
    return BundleModel;
}(BaseModel));
export default BundleModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/BundleModel.ts
// module id = 8CpZ
// module chunks = 18